exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xm-order-detail[data-v-ce703ea2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-radius:5px;background:#fff}.xm-order-detail h1[data-v-ce703ea2]{margin-bottom:10px}.detail-container[data-v-ce703ea2]{padding:0 40px}@media (max-width:700px){.detail-container[data-v-ce703ea2]{padding:0 20px}}", ""]);

// exports
